var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-container"},[_c('video',{ref:"videoElement",staticStyle:{"width":"100%"},attrs:{"controls":"","autoplay":"","muted":""},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }